export default "__VITE_ASSET__eee9b593__"